import wardDlg from './wardDlg'
import storageDlg from './storageDlg'
import clothingDlg from './clothingDlg'

const clothingMan = {
  namespaced: true,
  modules: {
    wardDlg,
    storageDlg,
    clothingDlg
  }
}

export default clothingMan
